import React from 'react';
import {useContext} from "react";
import {CancellationProcessContext} from "./CancellationProcess.component";
import MoneyHelper from "../../../services/MoneyHelper";
import {withNamespaces} from "react-i18next";
import {AuthContext} from "../../member/components/AuthContext";
import {PaymentTypes} from "../../clubs/models/Plan";

const DowngradeComponent = (props) => {
  const {t} = props;
  const downgradeData = props.data.downgrade || {};
  const {cancelDetails, plans} = useContext(CancellationProcessContext);
  const {member} = useContext(AuthContext);

  const changeData = (key, value) => {
    props.setData({downgrade: {...downgradeData, [key]: value}});
  }

  const getDiscountedPrice = () => {
    const newPlan = cancelDetails.downgrade.name;
    const plan = plans.find(p => p.category === newPlan);
    const price = plan.mms_prices.find(m => m.payment_type === PaymentTypes.Monthly);
    return price.base_price;
  }

  return (
    <div className="cancellation-offer-component">
      <p>{t('member_cancellation_downgrade_description')}</p>
      <h3>{t('member_cancellation_downgrade_header')}</h3>

      <div className="cancellation-offer-info-block">
        {[
          {
            text: t('member_cancellation_downgrade_current_price'),
            value: t('member_cancellation_downgrade_month_price', {
              price: MoneyHelper.toPrice(member.plan_info.nextDue),
              plan: member.membership_type
            })
          },
          {
            text: t('member_cancellation_downgrade_new_rate'),
            value: t('member_cancellation_downgrade_month_price', {
              price: MoneyHelper.toPrice(getDiscountedPrice()),
              plan: cancelDetails.downgrade.name
            }),
            isRedValue: true
          },
        ].map((item, index) => (
          <div key={index}>
            <div className='cancellation-offer-label'>{item.text}</div>
            <div className={`cancellation-offer-value ${item.isRedValue ? 'red-text' : ''}`}>{item.value}</div>
          </div>
        ))}
      </div>

      <p className='light light-grey'>{t('member_cancellation_downgrade_footnote')}</p>
    </div>
  );
};

export default withNamespaces()(DowngradeComponent);